module.exports = __webpack_public_path__ + "media/images/index/feature/top-aoj-a-a7d4359f25c91f290ebab1bcfa4d3272.png";